'use strict';


app.factory('Router', ['$location', '$rootScope',
    function ($location, $rootScope) {
        var service = {};


        /**
         * redirect if user is not selected
         *
         * @param String  send_type  drink | send-money
         */
        service.redirectIfUserIsNotSelected = function(send_type) {
            if( ! $rootScope.globals.selectedUser ){
            	return $location.path('/select-user/'+send_type);
            }
        };


        /**
         * redirect if venue is not selected
         */
        service.redirectIfVenueIsNotSelected = function() {
            if( ! $rootScope.globals.selectedVenue ){
                return $location.path('/venues');
            }
        };


        /**
         * redirect if drink is not selected
         */
        service.redirectIfDrinkIsNotSelected = function() {
            if( ! $rootScope.globals.selectedDrink ){
                return $location.path('/menu');
            }
        };


        /**
         * redirect if money is not selected
         */
        service.redirectIfMoneyIsNotSelected = function() {
            if( ! $rootScope.globals.selectedMoney ){
            	return $location.path('/select-money-amount');
            }
        };


        /**
         * redirect if something (user, venue, drink) is not selected
         */
        service.redirectIfSomethingIsNotSelected = function(){
            if( ! $rootScope.globals.selectedUser ){
                return $location.path('/');
            }

            if( ! $rootScope.globals.selectedVenue ){
                return $location.path('/venues');
            }

            if( ! $rootScope.globals.selectedDrink ){
                return $location.path('/menu');
            }
        }


        /**
         * checks if the current path is restricted
         * 
         * @return Boolean
         */
        service.isPathRestricted = function(){
            var current_path = $location.path();

            var restricted = $.inArray(current_path, ['', '/', '/login', '/register', '/update-password']) === -1;

            if( restricted )    restricted = current_path.indexOf('send-gift-to') === -1;
            if( restricted )    restricted = current_path.indexOf('invite') === -1;

            //if( restricted )    restricted = current_path.indexOf('event') === -1;
            //
            //if( ! restricted )    restricted = (current_path.indexOf('event') > -1) && (current_path.indexOf('select-tickets') > -1);

            if( restricted )    restricted = current_path.indexOf('tickets') === -1;

            if( ! restricted )    restricted = (current_path.indexOf('tickets') > -1) && (current_path.indexOf('select-tickets') > -1);

            return restricted;
        }


        /**
         * return true if intended path should be remembered
         * 
         * @return Boolean
         */
        service.shouldRememberIntendedPath = function(){
            var current_path = $location.path();

            var remember = $.inArray(current_path, ['/select-user/drink', '/select-user/send-money', '/venues', '/select-money-amount', '/menu']) !== -1;

            //if( ! remember )    remember = (current_path.indexOf('event') > -1) && (current_path.indexOf('select-tickets') > -1);

            if( ! remember )    remember = (current_path.indexOf('tickets') > -1) && (current_path.indexOf('select-tickets') > -1);

            return remember;
        }


        return service;
    }]);